import { UserStamp } from '@/@types/generated/models/UserStamp'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import format from '@/lib/format'
import { cn } from '@/lib/utils'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { ComponentProps } from 'react'

interface UserStampTooltipProps {
  by?: UserStamp
}

export function UserStampTooltip({
  by,
  className,
  children,
  ...props
}: UserStampTooltipProps & ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            'text-muted-foreground text-sm whitespace-nowrap',
            className
          )}
        >
          {children || format.DateTime(by?.timestamp)}
        </span>
      </TooltipTrigger>
      {by && (
        <TooltipContent {...props}>
          <span>
            {format.DateTime(by.timestamp)}
            {' by '}
            {by.fullName}
          </span>
        </TooltipContent>
      )}
    </Tooltip>
  )
}
